export const faqs = [
  {
    question: 'What do you need for a paper core quote?',
    answer:
      'Inner diameter, wall thickness, core length, quantity and the winding application. A drawing or sample spec helps.',
  },
  {
    question: 'What is the difference between stretch film and shrink film?',
    answer:
      'Stretch film is wrapped under tension to hold goods together, usually on pallets. Shrink film is wrapped around a product and tightens when heat is applied. Tell us how you pack and we will point you to the right one.',
  },
  {
    question: 'What do you need for a fluting paper quote?',
    answer: 'Grade, GSM, roll width, roll diameter, quantity and delivery location.',
  },
  {
    question: 'Do you deliver outside the UAE?',
    answer: 'Yes, we supply customers in Oman and Saudi Arabia.',
  },
];
